import { render, staticRenderFns } from "./EcommerceProductCategoryAttributeList.vue?vue&type=template&id=3563e688&lang=pug&"
import script from "./EcommerceProductCategoryAttributeList.vue?vue&type=script&setup=true&lang=js&"
export * from "./EcommerceProductCategoryAttributeList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports